import React, { useState } from 'react'
import { Navigate } from 'react-router-dom';
// import axios from 'axios'

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from '../../actions/auth'
import './login.css';

const Login2 = ({login, isAuthenticated}) => {



  const [formData, setFormData] = useState({
    email: "",
    password: "",
    });

  const {email, password} = formData;

  const onChange = e => {
    setFormData ({...formData, [e.target.name]:e.target.value});
  }

  const onSubmit =  (e) => {
    e.preventDefault();
    login(email, password); 
    }


    //Redirect if logged in
  if(isAuthenticated){
    return <Navigate to="/fetch" />;
    } 

  return (
    <div className="relative isolate px-6 pt-28 lg:px-8">
        <div className="login-panel mx-auto max-w-7xl flex flex-col items-center">

        <div className="mx-auto">
            
                <div className="flex flex-col">


                    <div className="w-96 max-w-full">
                        <form className="bg-white px-4 sm:p-6 form rounded-sm outline outline-offset-2 outline-2 outline-zinc-300" onSubmit={onSubmit}>
                        <div className="sm: mb-4 sm:text-left">
                        <h1 className="text-3xl text-gray-900">Welcome Back</h1>
                        </div>
                        <div className='mb-4'>
                            <label  className="block font-quiet font-arimo">Email address</label>
                            <div className="mt-1 ">
                            <input 
                                id="email" 
                                name="email"
                                placeholder="Email Address" 
                                type="email"
                                value = {email}
                                onChange={e=>onChange(e)} 
                                required 
                                className="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                            </div>
                        </div>

                        <div className='mb-4'>
                            <div className="flex items-center justify-between">
                            <label className="block font-quiet font-arimo">Password</label>
                            </div>
                            <div className="mt-1 ">
                            <input 
                                id="password" 
                                name="password"
                                placeholder="Password" 
                                type="password"
                                value = {password}
                                onChange={e=>onChange(e)} 
                                required 
                                className=" block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-purple-600 sm:text-sm sm:leading-6 "/>
                            </div>
                        </div>

                        <div className='mt-6 mb-2'>
                            <button 
                                type="submit" 
                                className="flex w-full justify-center bg-purple-600 px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600">Sign In</button>
                        </div>
                        </form>

                        {/* <p className="mt-10 text-center text-sm text-gray-500">
                        Not a member?
                        <a href="#" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">Start a 14 day free trial</a>
                        </p> */}
                    </div>
                    </div>


            
            </div>
        </div>
</div>


    //   <Fragment>
        
    //     <h1 className="large text-primary bg-green-400">Sign In</h1>
    //     <p className="lead btn_test_tw"><i className="fas fa-user"></i> Sign into your account</p>
    //     <form className="form" onSubmit={onSubmit}>
    //       <div className="form-group">
    //         <input
    //           type="email"
    //           placeholder="Email Address"
    //           name="email"
    //           value = {email}
    //           onChange={e=>onChange(e)}
    //           required
    //         />
    //       </div>
    //       <div className="form-group">
    //         <input
    //           type="password"
    //           placeholder="Password"
    //           name="password"
    //           value = {password}
    //           onChange={e=>onChange(e)}
    //           required
    //         />
    //       </div>
    //       <input type="submit" className="btn btn-primary" value="Login" />
    //     </form>
    //     {/* <p className="my-1">
    //       Don't have an account? <Link to="/register">Sign Up</Link>
    //     </p> */}
        
    // </Fragment>
    
  )
    
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

Login2.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool
}

// Note you're goign to get an error in the console over isAuthenticated.
// It starts off as null, and only once it fails/succeeds to load the user it
// becomes a boolean. PropTypes doesn't really support saying it should be either this or that.
// The given advice is to drop .isRequired, but it's a lot easier to pick up bugs with it so...

export default connect(mapStateToProps,{ login })(Login2);
